<template>
  <custom-popup
    v-model="dialog"
    :cons="{ title: $t('qrwinnersList.winnersList'), icon: 'trophy' }"
    hide-confirm
    max-width="1240"
    reloadable
    @close="resetFields"
    :key="$i18n.locale"
    @reload="handleReload"
  >
    <v-card class="pa-4" flat>
      <v-progress-linear v-show="loading" class="mb-2" indeterminate />
      <v-card
        class="mx-auto pa-3 rounded-lg mb-4"
        outlined
        color="grey lighten-4"
        elevation="2"
      >
        <v-card-title>
          <v-col cols="6" md="4" sm="12" class="pa-0">
            {{ $t("qrwinnersList.winnerstotalcount") }}:
            <strong>{{ use_lang(totalWinner) || "" }}</strong>
          </v-col>
          <v-col cols="6" md="4" sm="12" class="pa-0">
            {{ $t("qrwinnersList.winnerscountoffilter") }}:
            <strong>{{ use_lang(total) || "-" }}</strong>
          </v-col>
        </v-card-title>
      </v-card>

      <vue-table :data="data" :headers="winnersColumns" @change="onPagination">
        <template v-slot:filters="{ props, perPage }">
          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.length"
                :items="perPage"
                class="rounded-lg"
                dense
                hide-details
                :label="$t('qrwinnersList.perPage')"
                outlined
              />
            </v-col>
            <v-col class="pa-2" cols="12" lg="3" md="4">
              <v-text-field
                v-model="props.search"
                append-icon="mdi-magnify"
                class="rounded-lg"
                clearable
                dense
                hide-details
                :label="$t('qrwinnersList.search')"
                outlined
              />
            </v-col>
            <!-- <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.column"
                :items="columnOptions"
                :label="$t('qrwinnersList.sortColumn')"
                dense
                outlined
                class="rounded-lg"
              />
            </v-col> -->
            <v-col class="pa-2" cols="12" lg="2" md="3">
              <v-select
                v-model="props.dir"
                :items="dirOptions"
                :label="$t('qrwinnersList.sortDirection')"
                dense
                outlined
                class="rounded-lg"
              />
            </v-col>
          </v-row>
        </template>
        <template v-slot:index="{ item }">
          {{
            use_lang(item.index + 1 + (data.current_page - 1) * data.per_page)
          }}
        </template>

        <template v-slot:username="{ item }">
          {{ item.user.name }} {{ item.user.family }}
        </template>
        <template v-slot:prizename="{ item }">
          {{ item.prize.name }}
        </template>
        <template v-slot:mobile="{ item }">
          {{ use_lang(item.user.mobile.replace("+", "")) }}
        </template>

        <template v-slot:reward_key="{ item }">
          {{ item.prize.reward_key }}
        </template>

        <template v-slot:reward_value="{ item }">
          {{ item.prize.reward_value }}
        </template>

        <template v-slot:created_at="{ item }">
          {{ datetime(item.created_at, "datetime") }}
        </template>

        <template v-slot:id="{ item }">
          {{ use_lang(item.id) }}
        </template>
      </vue-table>
    </v-card>
  </custom-popup>
</template>

<script>
import ordersListButton from "@/view/components/adapters/qrList/ordersListButton.vue";
import { dataTableProps } from "@/main";
import { mapGetters, mapState } from "vuex";

export default {
  name: "qrWinnersList",
  components: { ordersListButton },

  props: {
    value: Boolean,
    address: String,
  },

  data() {
    return {
      info:{},
      data: null,
      total: 0,
      totalWinner: 0,
      winners: [],
      tableProps: {
        search: "",
        length: 15,
        column: "id",
        dir: "desc",
        page: 1,
      },
      loading: false,

      columnOptions: [
        { text: this.$t("qrwinnersList.WinnersColumns.id"), value: "id" },
        { text: "نام جایزه", value: "prize.name" },
        { text: "نام کاربر", value: "user.name" },
        { text: "فامیلی کاربر", value: "user.family" },
        { text: "موبایل", value: "user.mobile" },
        { text: "کلید جایزه", value: "prize.reward_key" },
        { text: "مقدار جایزه", value: "prize.reward_value" },
        { text: "تاریخ", value: "created_at" },
      ],
      dirOptions: [
        { text: "نزولی", value: "desc" },
        { text: "صعودی", value: "asc" },
      ],
    };
  },

  computed: {
    ...mapGetters("ribbon", ["user"]),
    ...mapState("localstorage", ["createQrID"]),

    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    winnersColumns() {
      return [
        { value: "index", text: "ردیف", align: "center", sortable: false },
        {
          value: "id",
          text: "شناسه",
          align: "center",
          sortable: true,
        },
        {
          value: "username",
          text: "برنده (نام و نام خانوادگی)",
          align: "center",
          sortable: false,
        },
        {
          value: "prizename",
          text: "نام جایزه",
          align: "center",
          sortable: false,
        },
        {
          value: "mobile",
          text: "شماره تماس",
          align: "center",
          sortable: false,
        },
        {
          value: "reward_key",
          text: "کلید جایزه",
          align: "center",
          sortable: true,
        },
        {
          value: "reward_value",
          text: "مقدار جایزه",
          align: "center",
          sortable: false,
        },
        {
          value: "created_at",
          text: "تاریخ برنده شدن",
          align: "center",
          sortable: true,
        },
      ];
    },
  },

  watch: {
"info.id"(newId) {
      if (newId) {
        this.calculateTotalWinners();
      }
    },
    value(val) {
      if (val) {
        this.fetchData().then(() => {
          this.fetch();
        });
      }
    },
    },

  methods: {
    fetchData() {
      this.loading = true;
      console.log(this.address ,"qrwinnerlist")
      
      return this.$api
        .get(`/v1/testQr/find/${this.address}`)
        .then(({ data }) => {
          this.info = data.data;
        })
        .finally(() => (this.loading = false));
    },
    calculateTotalWinners() {
      if (!!this.info && !!this.info?.id) {
        this.$api
          .get(`/v1/testQr/wheels/history-c/${this.info.id}`)
          .then(({ data }) => {
            this.totalWinner = data.data.count || this.total;
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error("خطا در دریافت تعداد برندگان");
          })
          .finally(() => {
            this.loading = false;
          });
      } else this.totalWinner = 0;
    },
    handleReload() {
      this.fetch();
      this.calculateTotalWinners();
    },

    fetch(props = this.tableProps) {
      this.loading = true;
      if (!this.info.id) {
        this.$toast.error("شناسه چرخ کیوآر موجود نیست");
        this.loading = false;
        return;
      }
      this.$api
        .get(`/v1/testQr/wheels/history/${this.info.id}`, {
          params: {
            search: props.search || "",
            column: props.column,
            dir: props.dir,
            page: props.page,
            length: props.length,
          },
        })
        .then(({ data }) => {
          console.log(data, "winners data");
          this.total = data.data.total;
          this.data = data.data;
          this.winners = data.data.data;
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("خطا در دریافت لیست برندگان");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onPagination(e) {
      const changed =
        e.page !== this.tableProps.page ||
        e.length !== this.tableProps.length ||
        e.search !== this.tableProps.search ||
        e.column !== this.tableProps.column ||
        e.dir !== this.tableProps.dir;

      if (changed) {
        Object.assign(this.tableProps, e);
        this.fetch();
      }
    },

    resetFields() {
      this.winners = [];
      this.total = 0;
      this.tableProps = {
        search: "",
        length: 15,
        column: "id",
        dir: "desc",
        page: 1,
      };
    },
  },
};
</script>
<style scoped>
.teal-lighten-4 {
  background-color: #b2dfdb !important;
  color: #fff !important;
}
.red-lighten-4 {
  background-color: #ffcdd2 !important;
  color: #fff !important;
}
</style>
